export default __webpack_public_path__ + "static/media/application_history_grey.8aa168e6.svg";